export default __webpack_public_path__ + "static/media/Himalayas-3.3d8e0082.jpg";